import { preview } from '@/components/form/preview'

import { useTexts } from '../../hooks/useTexts'

interface Props {
  showPicturePod: boolean
  showSignaturePod: boolean
  showAudioPod: boolean
  showNotePod: boolean
}

export function Pods(props: Props) {
  const { showNotePod, showSignaturePod, showAudioPod, showPicturePod } = props

  const texts = useTexts()

  const noPodsToShow = !showNotePod && !showSignaturePod && !showAudioPod && !showPicturePod

  return (
    <preview.Field testId="trackingPage-podsTitle" label={texts.podsTitle}>
      {showPicturePod && <preview.Value>{texts.picture}</preview.Value>}

      {showSignaturePod && <preview.Value>{texts.signature}</preview.Value>}

      {showAudioPod && <preview.Value>{texts.voiceMemo}</preview.Value>}

      {showNotePod && <preview.Value>{texts.driverNote}</preview.Value>}

      {noPodsToShow && <preview.Value>-</preview.Value>}
    </preview.Field>
  )
}
